module.exports = __webpack_public_path__ + "static/media/goodnest2_preview.d40ba15d.jpg";